/* By Lilo — maatadviseur.
   Types: harnas (borst + gewicht → XS–XXL), ytuig (borst + hals → Klein/Groot),
   halsband (nek → S/M/L). Maattabellen als JSON op het element (uit shop-metafield
   custom.maat_specs of de ingebouwde default). */
(function () {
  function init(el) {
    if (el.dataset.blInit) return;
    el.dataset.blInit = '1';
    var specs = JSON.parse(el.querySelector('[data-bl-specs]').textContent);
    var type = el.dataset.type;
    var spec = specs[type];
    if (!spec) return;
    var result = el.querySelector('.bl-advisor__result');
    var resultText = el.querySelector('[data-bl-result-text]');
    var strings = JSON.parse(el.querySelector('[data-bl-strings]').textContent);
    var inputs = {};
    el.querySelectorAll('input[data-field]').forEach(function (i) { inputs[i.dataset.field] = i; });

    function fits(maat, values) {
      return spec.velden.every(function (f) {
        if (f === 'gewicht') return true; // gewicht is een hint, geen harde grens
        var range = maat[f];
        var v = values[f];
        return range && v >= range[0] && v <= range[1];
      });
    }

    function advise() {
      var values = {};
      var filled = true;
      spec.velden.forEach(function (f) {
        var v = parseFloat((inputs[f] && inputs[f].value || '').replace(',', '.'));
        if (isNaN(v)) filled = false;
        values[f] = v;
      });
      if (!filled) { result.hidden = true; return; }
      var matches = spec.maten.filter(function (m) { return fits(m, values); });
      var msg;
      if (matches.length === 1) {
        msg = strings.one.replace('{size}', matches[0].naam);
      } else if (matches.length > 1) {
        var names = matches.map(function (m) { return m.naam; }).join(' & ');
        msg = strings.two.replace('{size}', names);
      } else {
        msg = strings.none;
      }
      resultText.textContent = msg;
      result.hidden = false;
    }

    Object.keys(inputs).forEach(function (k) { inputs[k].addEventListener('input', advise); });
  }

  function boot() { document.querySelectorAll('.bl-advisor[data-type]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
